export default "EHPAD & santé — Collectivités | Solution Éco France";
